import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, LocalStorageService, AlertController, App, UserService } from '../mainpage';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-payment',
  templateUrl: 'payment.html'
})

export class PaymentPage extends MainPage {
    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, 
      public localStorageService: LocalStorageService, protected alertController: AlertController,
      protected userService: UserService,
      protected appCtrl: App) {
      super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
    }

    public loadPage(): void {
    }
}


// WEBPACK FOOTER //
// ./src/pages/about/payment.ts